import {Observable} from 'rxjs';
import {Inject, Injectable} from '@angular/core';

import {VerifyAuthUseCasePort} from '@features/auth/application/use_cases/verify-auth//verify-auth.use-case.port';

import {VerifyAuthResponseDto} from '@features/auth/application/use_cases/verify-auth/dto/verify-auth.response.dto';
import {VerifyAuthPayloadDto} from '@features/auth/application/use_cases/verify-auth/dto/verify-auth.payload.dto';
import {AuthPort} from '@features/auth/application/ports/auth.port';


@Injectable({providedIn: 'root'})
export class VerifyAuthUseCase implements VerifyAuthUseCasePort {
  constructor(
    @Inject(AuthPort)
    private readonly authPort: AuthPort
  ) {
  }

  public execute(payload: VerifyAuthPayloadDto): Observable<VerifyAuthResponseDto> {
    return this.authPort.verify(payload);
  }
}
